enum AsideMenu {
  isMenuOpened = 'isMenuOpened',
}

/**
 * Sets the state of the aside menu in session storage.
 * @param open - A boolean indicating whether the menu should be opened or closed.
 */
export const setMenuState = (open: boolean) => {
  sessionStorage.setItem(AsideMenu.isMenuOpened, JSON.stringify(open));
};

/**
 * Retrieves the state of the aside menu from session storage.
 * @returns A boolean indicating whether the menu is currently open or not.
 * If there is no saved state, returns false.
 */
export const getMenuState = () => {
  const isMenuOpened = sessionStorage.getItem(AsideMenu.isMenuOpened);
  return isMenuOpened ? !!JSON.parse(isMenuOpened) : false;
};
